import { type InsuranceCorporateIdentity } from "../types";

export function DevkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M435.355 242.216L472 309.962H441.073L416.869 264.58L403.847 280.51V309.953H373.02V203.152H403.847V247.465L437.167 203.152H467.442L435.355 242.216ZM238.898 309.962H164.348V203.161H235.219V221.281H194.206V244.026H233.878V261.765H194.188V288.873H238.898V309.962ZM326.995 309.941H282.312L252.336 203.14H284.297L304.939 289.866L327.847 203.14H356.98L326.995 309.941ZM44 309.982V203H91.6643C103.191 203 121.323 203.117 131.744 214.513C141.966 225.691 142.808 245.277 142.808 256.192C142.808 301.945 119.003 310 87.9037 310L44 309.982ZM85.7198 290.685C89.2929 290.622 92.9737 290.449 96.5757 289.583C108.41 286.735 111.364 278.903 112.57 270.54C113.357 265.065 113.574 261.118 113.574 255.769C113.574 250.296 113.423 244.808 112.429 239.332C111.715 234.81 110.157 230.127 107.146 226.86C101.594 220.825 92.865 220.964 86.7212 220.964H75.3035L75.3016 290.638C78.7731 290.695 82.2446 290.756 85.7134 290.695L85.7198 290.685Z"
        fill="white"
      />
    </svg>
  );
}

export const DEVK: InsuranceCorporateIdentity = {
  id: "devk",
  name: "DEVK",
  logo: DevkLogo,
  backgroundColor: "#008746",
  textColor: "#FFFFFF",
  wildcard: "devk",
  type: "private",
};
